export default {
    modalQuickActionVariations: {
        title: 'AI',
        generateWithAi: 'Generer med AI',
        improveWriting: 'Forbedre skriving',
        fixSpelling: 'Fiks stavefeil og grammatiske feil',
        simplifyWriting: 'Forenkle skriving',
        makeLonger: 'Gjør det lengre',
        makeShorter: 'Forkort',
        replaceText: 'Erstatt tekst',
        addBelow: 'Legg til under',
        cancel: 'Avbryt',
        selectQuickActionTitle: 'Si til AI hva den skal gjøre videre...',
        regenerate: 'Regenerere',
    },
};
